import { get } from "lodash";
// import { useRecoilValue } from "recoil";
// import { CompanyDetails } from "Recoil/LoggedInUserDetail/selector";

export const Tabs = permissions => {
  // const companyDetail = useRecoilValue(CompanyDetails)
  const {
    departmentReport,
    executiveReport,
    coachingReport,
    transcriptReport
  } = permissions;

  const tabContent = [];
  if (
    get(transcriptReport, "readAccess", false) ||
    get(transcriptReport, "writeAccess", false) ||
    get(transcriptReport, "modifyAccess", false) ||
    get(transcriptReport, "deleteAccess", false)
  ) {
    // if(companyDetail?.feature?.createSuccessStory)
    tabContent.push({
      text: "Success stories",
      key: "SUCCESSSTORIES"
    });
    // if (companyDetail?.feature?.createPerformanceReview)
    tabContent.push({
      text: "Performance reviews",
      key: "PERFORMANCEREVIEW"
    });
  }

  if (get(departmentReport, "readAccess", false)) {
    tabContent.push({
      text: "Department overview",
      key: "DEPARTMENTS"
    });
  }

  if (get(coachingReport, "readAccess", false)) {
    tabContent.push({
      text: "Coaching comparison",
      key: "COACHING"
    });
  }
  if (get(executiveReport, "readAccess", false)) {
    tabContent.push({
      text: "Executive snapshot",
      key: "EXECUTIVE"
    });
  }
  return tabContent;
};